import { Box, Typography } from "@mui/material";

import { HeaderStyled } from "../../pages/CustomersPage/styles";

interface Props {
    title: string;
    subtitle: string;
    icon?: JSX.Element;
}

export function HeaderPage({ title, subtitle, icon }: Props) {
    return (
        <HeaderStyled>
            {icon && (
                <span
                    className="tableIcon"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "var(--secondary)",
                        borderRadius: "8px",
                        padding: "10px",
                        height: "42px",
                        width: "42px",
                        color: "white",
                    }}
                >
                    {icon}
                </span>
            )}

            <Box display="flex" flexDirection="column" gap={0.2}>
                <Typography variant="h5" fontWeight={700}>
                    {title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {subtitle}
                </Typography>
            </Box>
        </HeaderStyled>
    );
}
